import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import AddUserIco from "../../../assets/icons/AddUserIco";
import XCloseIco from "../../../assets/icons/XCloseIco";
import CommonButton from "../../../component/Button";
import CommonTextField from "../../../component/Input";
import CommonAccordion from "../../common-components/CommonAccordion";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../matches/quick-match/components/StyledComponent";
import AddGroup from "./AddGroup";
import PermissionsTable from "./PermissionTable";

export default function AddGroupPermission({
  openDialog,
  handleCloseDialog,
  isEdit,
}) {
  return (
    <Dialog
      fullWidth
      maxWidth={"lg"}
      open={openDialog}
      onClose={handleCloseDialog}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          background: "#FFF",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        },
      }}
    >
      {/* <img
        // src={NoteBackgroundImg}
        // style={{ position: "absolute", width: "max-content", opacity: "0.7" }}
        /> */}
      <StyledSpaceBetweenBox>
        <div>
          <IconButton
            size="small"
            sx={{
              border: "1px solid #D0D5DD",
              borderRadius: "8px",
              padding: "12px",
              marginLeft: "16px",
              marginTop: "16px",
            }}
          >
            <AddUserIco />
          </IconButton>
        </div>
        {/* <DialogActions> */}
        <Button onClick={handleCloseDialog} sx={{ marginTop: "10px" }}>
          <XCloseIco />
        </Button>
        {/* </DialogActions> */}
      </StyledSpaceBetweenBox>
      <DialogTitle>
        <Typography variant="h3" sx={{ mt: 2 }}>
          {/* {isEdit ? "Edit Note" : "Create Note"} */}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Grid2 spacing={2} container>
          <Grid2 size={12}>
            <Typography variant="h2" color="#101828">
              {isEdit ? "Edit Group" : "Add Group"}
            </Typography>
          </Grid2>
          <Grid2 size={3}>
            <CommonTextField placeholder={"Enter Group Name"} />
          </Grid2>
          <Grid2 size={12}>
            <AddGroup />
          </Grid2>

          <Grid2 size={12}>
            <CommonAccordion
              title={"Permission"}
              //   children={
              //     <MixedComponent editData={primaryData} loading={isLoading} />
              //   }
              children={<PermissionsTable />}
            />
          </Grid2>

          <CommonGrid2
            item
            size={{ xs: 12 }}
            gap="10px"
            display="flex"
            justifyContent={"end"}
          >
            <CommonButton
              variant="outlined"
              color="#344054"
              border="#D0D5DD"
              fontWeight="600"
              value="Cancel"
              padding="8px 20px"
              onClick={handleCloseDialog}
            />
            <CommonButton
              variant="contained"
              color="white"
              background="#7F56D9"
              fontWeight="600"
              value="Save Settings"
              padding="8px 20px"
              //   type="submit"
            />
          </CommonGrid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
}
